import { init } from '@amplitude/analytics-browser';

// Own
import { AMPLITUDE_API_KEY } from 'constants/env-variables';

init(AMPLITUDE_API_KEY);
